// @ts-nocheck
// Greif UI Kit = line-minus
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const Minus: React.FC = () => {
    /* Store Custom Code - Start */
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18 12.733H5.867a.867.867 0 1 1 0-1.733H18a.867.867 0 1 1 0 1.733"
                clipRule="evenodd"
            />
        </svg>
    );
    /* Store Custom Code - End */
};

export const MinusOffset: IconOffset = {
    vertical: 45, // Store Custom Code
    horizontal: 20, // Store Custom Code
};

export default React.memo(Minus);
